import React, { useState, useEffect } from "react";
import "./signup.css";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import NavbarLog from "../NavbarLog/NavbarLog";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import ChatBot from "../../Chatbot/chatbot";
const Signup = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [numTel, setNumTel] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleNameChange = (e) => setName(e.target.value);
  const handleSurnameChange = (e) => setSurname(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);
  const toggleShowPassword = () => setShowPassword(!showPassword);
  const toggleShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        className: "custom-toast custom-toast-error",
      });
    }

    const normalizedEmail = email.toLowerCase();
    const normalizedName = name.toLowerCase();
    const normalizedSurname = surname.toLowerCase();

    if (
      !normalizedEmail.includes(normalizedName) ||
      !normalizedEmail.includes(normalizedSurname)
    ) {
      return toast.error(
        "The email must contain your first name and last name.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          className: "custom-toast custom-toast-error",
        }
      );
    }

    const user = { name, surname, numTel, email, password };
    console.log("User sent:", user);

    try {
      const response = await fetch(`${API_URL}/users/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "Signup successful!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          className: "custom-toast custom-toast-success",
        });

        setTimeout(() => navigate("/login"), 5000);
      } else {
        toast.error(data.message || "Signup failed.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          className: "custom-toast custom-toast-error",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Server error.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        className: "custom-toast custom-toast-error",
      });
    }
  };

  return (
    <div className="container">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="toast-container"
      />
      <NavbarLog />
      <ChatBot  mode="public" />
      <div className="wrapper1" role="main" aria-label="Sign up form">
        <form onSubmit={handleSubmit} aria-labelledby="signup-heading">
          <h1 id="signup-heading">Sign Up</h1>

          <div className="input-box1">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={handleNameChange}
              required
              aria-label="Name"
            />
          </div>

          <div className="input-box1">
            <input
              type="text"
              placeholder="Surname"
              value={surname}
              onChange={handleSurnameChange}
              required
              aria-label="Surname"
            />
          </div>
          <div className="input-box1">
            <PhoneInput
              international
              countryCallingCodeEditable={false}
              defaultCountry="TN"
              value={numTel}
              onChange={setNumTel}
              placeholder="52 091 727"
              className="custom-phone-input"
              withCountryCallingCode
            />
          </div>
          <div className="input-box1">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              required
              aria-label="Email"
            />
          </div>

          <div className="input-box1 mdp">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
              required
              aria-label="Password"
            />
            <span
              onClick={toggleShowPassword}
              className="password-toggle-icon"
              aria-label={showPassword ? "Hide password" : "Show password"}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && toggleShowPassword()}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="input-box1">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              required
              aria-label="Confirm Password"
            />
            <span
              onClick={toggleShowConfirmPassword}
              className="password-toggle-icon"
              aria-label={
                showConfirmPassword
                  ? "Hide confirm password"
                  : "Show confirm password"
              }
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" && toggleShowConfirmPassword()
              }
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button type="submit" className="btn" aria-label="Sign Up">
            Sign Up
          </button>

          <div className="login-link">
            <p>
              Already have an account?
              <Link
                to="/login"
                className="text-primary text-gradient font-weight-bold"
                aria-label="Login"
              >
                Login
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signup;
